import React from "react";
import classNames from "classnames";

import { ProgressSpinnerProps, SpinnerProps } from "./LoadingIndicator.types";

import "./LoadingIndicator.scss";

export const ProgressSpinner = ({
  progress,
  showBackground,
  isLoading,
}: ProgressSpinnerProps) => {
  const spinnerClass = classNames(
    {
      ProgressSpinner: !showBackground,
      "ProgressSpinner--backgroundVisible": showBackground,
    },
    { hidden: !isLoading }
  );
  const radius = 40;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;
  return (
    <div className={spinnerClass} data-testid="progress-spinner">
      <svg height={"100"} width={"100"}>
        <circle className="ProgressSpinner-track" r={radius} cx={50} cy={50} />
        <circle
          className="ProgressSpinner-circle"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          r={radius}
          cx={50}
          cy={50}
        />
        <text
          x={"50%"}
          y={58}
          className="ProgressSpinner-progressText"
          data-testid="progress-spinner-text"
        >
          {progress}%
        </text>
      </svg>
    </div>
  );
};

export const Spinner = ({ size, isLoading }: SpinnerProps) => {
  const spinnerClass = classNames(`IndefiniteSpinner--${size}`, {
    hidden: !isLoading,
  });
  return <div data-testid="indefinite-spinner" className={spinnerClass} />;
};
